export const inputTypeToLabel: Record<api.ott.InputStream["type"], string> = {
  rtmp: "RTMP",
  srt: "SRT",
  virtual: "Static assets"
}

export const sortedStates = [
  "disabled",
  "down",
  "warning",
  "configuring",
  "ready",
  "active",
  undefined
] as const

export const longRefetchOptions = {
  refetchInterval: 10_000
}
